"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _auth = require("@/utils/auth");
var _permission = require("@/utils/permission");
var systemConfigApi = _interopRequireWildcard(require("@/api/systemConfig"));
var _MultiLangProductMaintain = _interopRequireDefault(require("@/components/i18n/MultiLangProductMaintain.vue"));
var _BatchInventoryAdjustDialog = _interopRequireDefault(require("@/components/product/BatchInventoryAdjustDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var TABLE_SCROLL_KEY_PREFIX = 'product_list_table_scroll_';
var _default = exports.default = {
  name: 'CoreProductList',
  components: {
    MultiLangProductMaintain: _MultiLangProductMaintain.default,
    BatchInventoryAdjustDialog: _BatchInventoryAdjustDialog.default
  },
  props: {
    bizType: {
      default: null,
      type: Number
    },
    createOrEditUrl: {
      default: null,
      type: String
    },
    detailUrl: {
      default: null,
      type: String
    },
    inventoryAdjustUrl: {
      default: null,
      type: String
    }
  },
  data: function data() {
    return {
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      customConfig: {},
      showLanguageBtn: false,
      // roterPre: roterPre,
      headeNum: [],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 10,
        cateId: '',
        keywords: '',
        type: '1',
        isAdminStar: '',
        sortColumn: '',
        order: ''
      },
      categoryList: [],
      merCateList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      dialogVisible: false,
      i18nPageDataVersion: 0,
      multipleSelection: [],
      batchCateDialogVisible: false,
      batchCatePath: [],
      batchCateProps: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: true,
        multiple: false
      },
      batchCateSubmitting: false,
      batchInventoryDialogVisible: false,
      batchInventoryProducts: [],
      restoreScrollAfterLoad: false,
      tableHeight: 400,
      savedTableScrollTop: 0,
      resizeTimer: null,
      tableResizeObserver: null
    };
  },
  computed: {
    currentPageBizIds: function currentPageBizIds() {
      return (this.tableData.data || []).map(function (item) {
        return item.id;
      }).filter(Boolean);
    },
    listScrollPath: function listScrollPath() {
      var pathMap = {
        1: '/product/index',
        2: '/pointsStore/index',
        3: '/leaseProduct/index'
      };
      return pathMap[this.bizType] || this.$route.path;
    }
  },
  created: function created() {
    var _this = this;
    if ((0, _permission.checkPermi)(['admin:system:language'])) {
      this.showLanguageBtn = true;
    }
    console.log('created.......');
    systemConfigApi.configInfo({
      id: "147"
    }).then(function (data) {
      _this.customConfig = data;
    });
  },
  mounted: function mounted() {
    this.lockPageScroll(true);
    this.initPage();
    this.calcPageHeight();
    this.initTableResizeObserver();
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    if (this.tableResizeObserver) {
      this.tableResizeObserver.disconnect();
      this.tableResizeObserver = null;
    }
    this.lockPageScroll(false);
  },
  deactivated: function deactivated() {
    this.saveScrollPosition();
    this.lockPageScroll(false);
  },
  activated: function activated() {
    var _this2 = this;
    this.lockPageScroll(true);
    this.calcPageHeight();
    var refreshed = this.handleRefreshQuery();
    if (!refreshed) {
      this.calcTableHeight(function () {
        _this2.restoreScrollPosition();
      });
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    initPage: function initPage() {
      if (this.handleRefreshQuery()) {
        this.getCategorySelect();
        this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
        return;
      }
      this.goodHeade();
      this.getList();
      this.getCategorySelect();
      this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
    },
    handleRefreshQuery: function handleRefreshQuery() {
      var _this$$route$query = this.$route.query,
        refresh = _this$$route$query.refresh,
        type = _this$$route$query.type;
      if (refresh !== '1') return false;
      if (type) {
        this.tableFrom.type = String(type);
      }
      this.restoreScrollAfterLoad = true;
      this.goodHeade();
      this.getList();
      this.clearRouteQuery(['refresh', 'type']);
      return true;
    },
    clearRouteQuery: function clearRouteQuery(keys) {
      var query = _objectSpread({}, this.$route.query);
      keys.forEach(function (key) {
        return delete query[key];
      });
      this.$router.replace({
        path: this.$route.path,
        query: query
      });
    },
    saveScrollPosition: function saveScrollPosition() {
      var bodyWrapper = this.getTableBodyWrapper();
      if (bodyWrapper) {
        this.savedTableScrollTop = bodyWrapper.scrollTop;
        sessionStorage.setItem(TABLE_SCROLL_KEY_PREFIX + this.listScrollPath, String(this.savedTableScrollTop));
      }
    },
    restoreScrollPosition: function restoreScrollPosition() {
      var _this3 = this;
      var raw = sessionStorage.getItem(TABLE_SCROLL_KEY_PREFIX + this.listScrollPath);
      var top = raw != null ? Number(raw) : this.savedTableScrollTop;
      if (!top || top <= 0) return;
      var apply = function apply() {
        var table = _this3.$refs.productTable;
        var bodyWrapper = table && table.bodyWrapper;
        if (!bodyWrapper) return;
        bodyWrapper.scrollTop = top;
      };
      this.$nextTick(function () {
        apply();
        [50, 100, 200, 350, 500, 700, 1000].forEach(function (delay) {
          return setTimeout(apply, delay);
        });
      });
    },
    getTableBodyWrapper: function getTableBodyWrapper() {
      var table = this.$refs.productTable;
      return table && table.bodyWrapper;
    },
    lockPageScroll: function lockPageScroll(lock) {
      var appMain = document.querySelector('.app-main');
      if (appMain) {
        appMain.style.overflow = lock ? 'hidden' : '';
      }
    },
    onWindowResize: function onWindowResize() {
      var _this4 = this;
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        _this4.calcPageHeight();
      }, 150);
    },
    initTableResizeObserver: function initTableResizeObserver() {
      var _this5 = this;
      if (typeof ResizeObserver === 'undefined') return;
      this.$nextTick(function () {
        var tableWrap = _this5.$refs.tableWrap;
        if (!tableWrap || _this5.tableResizeObserver) return;
        _this5.tableResizeObserver = new ResizeObserver(function () {
          _this5.calcTableHeight();
        });
        _this5.tableResizeObserver.observe(tableWrap);
      });
    },
    calcPageHeight: function calcPageHeight() {
      var _this6 = this;
      this.$nextTick(function () {
        var pageEl = _this6.$el;
        if (!pageEl) return;
        var shell = pageEl.closest('.product-page-shell, .lease-product-page');
        var top = shell ? shell.getBoundingClientRect().top : pageEl.getBoundingClientRect().top;
        var shellHeight = Math.max(360, window.innerHeight - top - 6);
        if (shell) {
          shell.style.height = "".concat(shellHeight, "px");
          shell.style.overflow = 'hidden';
          shell.style.display = 'flex';
          shell.style.flexDirection = 'column';
          pageEl.style.height = '100%';
          pageEl.style.flex = '1';
          pageEl.style.minHeight = '0';
        } else {
          pageEl.style.height = "".concat(shellHeight, "px");
        }
        _this6.calcTableHeight();
      });
    },
    formatPriceText: function formatPriceText(row) {
      var list = row.attrValue || [];
      if (!list.length) return '0.00元';
      return list.map(function (attr) {
        var price = attr.price ? "".concat(attr.price, "\u5143") : '0.00元';
        return row.specType === true && attr.suk ? "".concat(attr.suk, ":").concat(price) : price;
      }).join(' / ');
    },
    calcTableHeight: function calcTableHeight(done) {
      var _this7 = this;
      this.$nextTick(function () {
        var pageEl = _this7.$el;
        var tableWrap = _this7.$refs.tableWrap;
        var headerEl = pageEl && pageEl.querySelector('.product-list-header');
        var paginationEl = pageEl && pageEl.querySelector('.product-list-pagination');
        if (!pageEl) {
          if (done) done();
          return;
        }
        var wrapHeight = tableWrap ? tableWrap.clientHeight : 0;
        var height = wrapHeight > 0 ? wrapHeight - 4 : window.innerHeight - pageEl.getBoundingClientRect().top - (headerEl ? headerEl.offsetHeight : 0) - (paginationEl ? paginationEl.offsetHeight : 50) - 12;
        _this7.tableHeight = Math.max(300, Math.floor(height));
        _this7.$nextTick(function () {
          var table = _this7.$refs.productTable;
          if (table && table.doLayout) {
            table.doLayout();
          }
          _this7.updateTableScrollbarGutter();
          if (done) done();
        });
      });
    },
    updateTableScrollbarGutter: function updateTableScrollbarGutter() {
      var table = this.$refs.productTable;
      var tableEl = table && table.$el;
      if (!tableEl) return;
      var gutterWidth = table.layout && table.layout.scrollY ? Math.max(table.layout.gutterWidth || 0, 8) : 0;
      tableEl.style.setProperty('--product-table-scrollbar-width', "".concat(gutterWidth, "px"));
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    openBatchCateDialog: function openBatchCateDialog() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选商品');
        return;
      }
      this.batchCatePath = [];
      this.batchCateDialogVisible = true;
    },
    openBatchInventoryDialog: function openBatchInventoryDialog() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选商品');
        return;
      }
      this.batchInventoryProducts = this.multipleSelection.map(function (item) {
        return {
          id: item.id,
          storeName: item.storeName || "\u5546\u54C1".concat(item.id)
        };
      });
      this.batchInventoryDialogVisible = true;
    },
    onBatchInventorySuccess: function onBatchInventorySuccess() {
      this.multipleSelection = [];
      if (this.$refs.productTable) {
        this.$refs.productTable.clearSelection();
      }
      this.getList();
    },
    onBatchCateDialogClosed: function onBatchCateDialogClosed() {
      this.batchCateSubmitting = false;
    },
    batchPutOnShell: function batchPutOnShell() {
      var _this8 = this;
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选商品');
        return;
      }
      var ids = this.multipleSelection.map(function (r) {
        return r.id;
      }).filter(function (id) {
        return id != null;
      });
      this.$modalSure("\u5C06\u5DF2\u9009 ".concat(ids.length, " \u4E2A\u5546\u54C1\u4E0A\u67B6\uFF1F")).then(function () {
        (0, _store.productBatchPutOnShellApi)({
          ids: ids
        }).then(function (data) {
          var ok = data && data.successCount || 0;
          var fail = data && data.failCount || 0;
          var msg = "\u4E0A\u67B6\u5B8C\u6210\uFF1A\u6210\u529F ".concat(ok, " \u4E2A");
          if (fail > 0) {
            msg += "\uFF0C\u5931\u8D25 ".concat(fail, " \u4E2A");
            if (data.failDetails && data.failDetails.length) {
              msg += '。' + data.failDetails.slice(0, 5).join('；');
              if (data.failDetails.length > 5) msg += '…';
            }
          }
          _this8.$message.success(msg);
          if (_this8.$refs.productTable) {
            _this8.$refs.productTable.clearSelection();
          }
          _this8.multipleSelection = [];
          _this8.getList();
          _this8.goodHeade();
        });
      }).catch(function () {});
    },
    batchOffShell: function batchOffShell() {
      var _this9 = this;
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选商品');
        return;
      }
      var ids = this.multipleSelection.map(function (r) {
        return r.id;
      }).filter(function (id) {
        return id != null;
      });
      this.$modalSure("\u5C06\u5DF2\u9009 ".concat(ids.length, " \u4E2A\u5546\u54C1\u4E0B\u67B6\uFF1F")).then(function () {
        (0, _store.productBatchOffShellApi)({
          ids: ids
        }).then(function (data) {
          var ok = data && data.successCount || 0;
          var fail = data && data.failCount || 0;
          var msg = "\u4E0B\u67B6\u5B8C\u6210\uFF1A\u6210\u529F ".concat(ok, " \u4E2A");
          if (fail > 0) {
            msg += "\uFF0C\u5931\u8D25 ".concat(fail, " \u4E2A");
            if (data.failDetails && data.failDetails.length) {
              msg += '。' + data.failDetails.slice(0, 5).join('；');
              if (data.failDetails.length > 5) msg += '…';
            }
          }
          _this9.$message.success(msg);
          if (_this9.$refs.productTable) {
            _this9.$refs.productTable.clearSelection();
          }
          _this9.multipleSelection = [];
          _this9.getList();
          _this9.goodHeade();
        });
      }).catch(function () {});
    },
    submitBatchCate: function submitBatchCate() {
      var _this10 = this;
      var path = this.batchCatePath;
      var cateId = Array.isArray(path) && path.length ? path.join(',') : '';
      if (!cateId) {
        this.$message.warning('请选择分类');
        return;
      }
      var ids = this.multipleSelection.map(function (r) {
        return r.id;
      }).filter(function (id) {
        return id != null;
      });
      if (!ids.length) {
        this.$message.warning('未获取到商品 id');
        return;
      }
      this.batchCateSubmitting = true;
      (0, _store.productBatchUpdateCateApi)({
        ids: ids,
        cateId: cateId
      }).then(function () {
        _this10.$message.success('分类已更新');
        _this10.batchCateDialogVisible = false;
        if (_this10.$refs.productTable) {
          _this10.$refs.productTable.clearSelection();
        }
        _this10.multipleSelection = [];
        _this10.getList();
        _this10.goodHeade();
      }).catch(function (res) {
        _this10.$message.error(res.message || '操作失败');
      }).finally(function () {
        _this10.batchCateSubmitting = false;
      });
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (order) {
        this.tableFrom.sortColumn = this.camelToUnderline(prop);
        this.tableFrom.order = order === 'ascending' ? 'asc' : 'desc';
      } else {
        this.tableFrom.sortColumn = '';
        this.tableFrom.order = '';
      }
      this.tableFrom.page = 1;
      this.getList();
    },
    camelToUnderline: function camelToUnderline(str) {
      if (!str) return '';
      return str.replace(/[A-Z]/g, function (match) {
        return "_".concat(match.toLowerCase());
      }).replace(/^_/, '');
    },
    handleRestore: function handleRestore(id) {
      var _this11 = this;
      this.$modalSure("恢复商品").then(function () {
        (0, _store.restoreApi)(id).then(function (res) {
          _this11.$message.success('操作成功');
          _this11.goodHeade();
          _this11.getList();
        });
      });
    },
    reset: function reset() {
      this.tableFrom = {
        page: 1,
        limit: 10,
        cateId: '',
        keywords: '',
        type: '1',
        isAdminStar: '',
        sortColumn: '',
        order: ''
      };
      this.getList();
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 复制
    // 导出
    exports: function exports() {
      (0, _store.productExcelApi)({
        cateId: this.tableFrom.cateId,
        keywords: this.tableFrom.keywords,
        type: this.tableFrom.type,
        bizType: this.bizType
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this12 = this;
      (0, _store.productHeadersApi)({
        bizType: this.bizType
      }).then(function (res) {
        _this12.headeNum = res;
      }).catch(function (res) {
        _this12.$message.error(res.message);
      });
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this13 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this13.merCateList = res;
      }).catch(function (res) {
        _this13.$message.error(res.message);
      });
    },
    // 列表
    getList: function getList() {
      var _this14 = this;
      this.listLoading = true;
      this.tableFrom.bizType = this.bizType;
      var shouldRestoreScroll = this.restoreScrollAfterLoad;
      (0, _store.productLstApi)(this.tableFrom).then(function (res) {
        _this14.tableData.data = res.recordList;
        _this14.tableData.total = res.recordCount;
        _this14.i18nPageDataVersion += 1;
        _this14.listLoading = false;
        if (shouldRestoreScroll) {
          _this14.restoreScrollAfterLoad = false;
          _this14.calcTableHeight(function () {
            _this14.restoreScrollPosition();
          });
        } else {
          _this14.calcTableHeight();
        }
      }).catch(function (res) {
        _this14.listLoading = false;
        _this14.$message.error(res.message);
        if (shouldRestoreScroll) {
          _this14.restoreScrollAfterLoad = false;
          _this14.calcTableHeight(function () {
            _this14.restoreScrollPosition();
          });
        }
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this15 = this;
      this.$modalSure("\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u5546\u54C1")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        (0, _store.productDeleteApi)(id, deleteFlag).then(function () {
          _this15.$message.success('删除成功');
          _this15.getList();
          _this15.goodHeade();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this16 = this;
      row.isShow ? (0, _store.putOnShellApi)(row.id).then(function () {
        _this16.$message.success('上架成功');
        _this16.getList();
        _this16.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : (0, _store.offShellApi)(row.id).then(function () {
        _this16.$message.success('下架成功');
        _this16.getList();
        _this16.goodHeade();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    onStar: function onStar(row) {
      var _this17 = this;
      row.isAdminStar ? (0, _store.adminStar)(row.id).then(function () {
        _this17.$message.success('标星成功');
        _this17.getList();
        _this17.goodHeade();
      }).catch(function () {
        row.isAdminStar = !row.isAdminStar;
      }) : (0, _store.cancelAdminStar)(row.id).then(function () {
        _this17.$message.success('取消标星');
        _this17.getList();
        _this17.goodHeade();
      }).catch(function () {
        row.isAdminStar = !row.isAdminStar;
      });
    }
  }
};